"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var styled_components_1 = __importStar(require("styled-components"));
var styled_system_1 = require("styled-system");
var gridTheme_1 = require("../gridTheme");
var sizeFn = function (props) {
    var finalSize = {
        fontSize: [],
        padding: []
    };
    var sizes = {
        small: {
            fontSize: props.theme.fontSizes[0] + "px",
            padding: '7px 12px'
        },
        medium: {
            fontSize: props.theme.fontSizes[1] + "px",
            padding: '9.5px 18px'
        },
        large: {
            fontSize: props.theme.fontSizes[2] + "px",
            padding: '12px 22px'
        },
        xLarge: {
            fontSize: props.theme.fontSizes[4] + "px",
            padding: '9.5px 38px'
        }
    };
    var parsedSize = Array.isArray(props.size) ? props.size : [props.size];
    parsedSize.forEach(function (size) {
        finalSize.fontSize.push(sizes[size].fontSize);
        finalSize.padding.push(sizes[size].padding);
    });
    return gridTheme_1.mq(finalSize);
};
var minWidth = function (props) { return gridTheme_1.mq({ minWidth: props.minWidth }); };
var width = function (props) { return (props.fullWidth ? { width: '100%' } : undefined); };
var raised = function (props) {
    switch (props.raised) {
        case 0:
            return { boxShadow: 'none' };
        case 1:
            return { boxShadow: '0px 5px 5px -2px rgba(0,0,0,0.15)' };
        case 2:
            return { boxShadow: '0px 9px 8px -4px rgba(0,0,0,0.15)' };
        case 3:
            return { boxShadow: '0px 12px 11px -2px rgba(0,0,0,0.1)' };
        default:
            return { boxShadow: '0px 5px 5px -2px rgba(0,0,0,0.15)' };
    }
};
var Button = styled_components_1["default"].button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-family: inherit;\n  font-weight: ", ";\n  line-height: ", ";\n  cursor: pointer;\n  border-radius: ", ";\n  ", ";\n  border-width: 0;\n  border-style: solid;\n  transition: background-color ", "\n    ", " 0ms;\n\n  ", "\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n"], ["\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-family: inherit;\n  font-weight: ", ";\n  line-height: ", ";\n  cursor: pointer;\n  border-radius: ", ";\n  ", ";\n  border-width: 0;\n  border-style: solid;\n  transition: background-color ", "\n    ", " 0ms;\n\n  ",
    "\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  &:hover {\n    background-color: ",
    ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontWeights.bold;
}, function (_a) {
    var theme = _a.theme;
    return theme.lineHeights.standard;
}, function (_a) {
    var theme = _a.theme;
    return theme.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorStyles.primaryTextOnPrimary;
}, function (_a) {
    var theme = _a.theme;
    return theme.duration.slow;
}, function (_a) {
    var theme = _a.theme;
    return theme.timingFunctions.easeOut;
}, function (_a) {
    var caps = _a.caps;
    return caps && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      text-transform: uppercase;\n    "], ["\n      text-transform: uppercase;\n    "])));
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? null : theme.colors.secondary;
}, raised, width, minWidth, function (_a) {
    var theme = _a.theme, size = _a.size;
    return sizeFn({ theme: theme, size: size });
}, styled_system_1.space);
Button.displayName = 'Button';
Button.defaultProps = {
    fullWidth: false
};
exports["default"] = Button;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Button.js.map